// extracted by mini-css-extract-plugin
module.exports = {"container":"Privacy_container__3YiGC","section":"Privacy_section__VJ1P3","opn-nav":"Privacy_opn-nav__3rEv8"};